// extracted by mini-css-extract-plugin
export default {"wrap":"Code_wrap__Cgtmk","code":"Code_code__aADBc","copy":"Code_copy__dNb-G","copyShow":"Code_copyShow__en3f0"};